export default __webpack_public_path__ + "static/media/hotel_4.8cc1304b.webp";